export default "__VITE_ASSET__BXVd9Wrh__"